<template>
  <!-- 未读消息 -->
  <div class="notice">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  v-show="list.length > 0">
      <div class="notice-item" v-for="item in list">
        <div class="item">
          <div class="item-left">
            <span class="circle"></span>
             <span class="name">{{item.title}}</span>
          </div>
          <p class="data">{{item.createdTime}}</p>
        </div>
        <p class="bottom">
           <span v-html="item.content"></span>
        </p>
      </div>
    </van-list>
    <noNoticetList v-show="list.length == 0"></noNoticetList>
  </div>
</template>

<script>
  import noNoticetList from '@/components/noNoticetList'
  import { unnoticeList } from '@/api/notice/notice.js'
  import { getCookie } from '@/utils/cookies'
  export default{
    name: 'readnotice',
    data(){
      return{
        loading: false,
        finished: false,
        list:[],
        listQuery:{
          toUser: '',
          pageSize: 10,
          pageNum: 1,
          readed: 1
        },
      }
    },
    created() {
      this.listQuery.toUser = getCookie('accountId')
      this.getData();
    },
    components: { noNoticetList },
    methods:{
      // 获取数据
      getData(){
        this.listQuery.pageNum = 0
        this.listQuery.pageSize = 10
        this.finished = false
        this.onLoad()
      },
      // 获取数据
      onLoad () {
         // 调用查询接口
         let self = this
         this.listQuery.pageNum++
         unnoticeList(this.listQuery).then(result => {
            if (result && result.status === 200 && result.data  && result.data.data.list && result.data.data.list.length > 0) {
             self.list = self.list.concat(result.data.data.list)
             self.listQuery.pageNum = result.data.data.pages
             window.setTimeout(() => {
               self.loading = false
               if (self.list.length == result.data.data.total) {
                 self.finished = true
               }
             }, 1000)
           } else {
             self.loading = false
             self.finished = true
           }
         }).catch(() => {
           self.loading = false
           self.listQuery.total = 0
         })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .notice{
    background: #EFEFF4;
    min-height: calc(100vh - 100px);
    .notice-item{
      font-size: 12px;
      margin-bottom: 12px;
      .item{
        background: #FFF;
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
        padding-top: 10px;
        .circle{
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 50%;
        }
        .name{
          font-weight: bold;
        }
        .data{
          color: #FF0000;
        }
      }
      .bottom{
        padding: 10px 16px;
        padding-left: 27px;
        background: #fff;
        color: #888888;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/notice/readNotice.vue